import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ListItemIcon from '@mui/material/ListItemIcon';
import SearchIcon from '@mui/icons-material/Search';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function TabList() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const drawerItems = [
    { label: 'Buscador', value: 0, icon: <SearchIcon />, color: '#ffffff' },
    { label: 'Mis clases', value: 1, icon: <CalendarTodayIcon />, color: '#ffffff' },
    { label: 'Time Line', value: 2, icon: <ScheduleIcon />, color: '#ffffff' },
  ];

  // Definimos un objeto de estilos para cambiar el color del indicador y el texto seleccionado
  const tabStyles = {
    selectedTextColor: '#ffffff', // Color del texto de la pestaña seleccionada
    disabledTextColor: '#cccccc', // Color del texto de la pestaña deshabilitada
  };

  return (
    <Box display="flex" justifyContent="center">
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        allowScrollButtonsMobile // Mostrar flechas en dispositivos móviles
      >
        {drawerItems.map((item) => (
          <Tab
            key={item.value}
            label={
              <React.Fragment>
                <span style={{ display: 'flex', alignItems: 'center', color: value === item.value ? tabStyles.selectedTextColor : tabStyles.disabledTextColor }}>
                  <ListItemIcon sx={{ marginRight: '3px', color: value === item.value ? '#ffffff' : '#cccccc' }}>
                    {item.icon}
                  </ListItemIcon>
                  <span style={{ fontWeight: 'bold' }}>{item.label}</span>
                </span>
                {item.value !== 0 && value !== item.value && (
                  <Typography variant="caption" color="textSecondary" align="center">
                    (En desarrollo)
                  </Typography>
                )}
              </React.Fragment>
            }
            disabled={item.value !== 0 && value !== item.value}
          />
        ))}
      </Tabs>
    </Box>
  );
}

export default TabList;
